import React from 'react';

const Footer = ({ onNavigate, onOpenPrivacyChoices }) => (
  <div className="footer-shell">
    <div className="footer-links" aria-label="Footer navigation">
      <button type="button" className="footer-link-btn" onClick={() => onNavigate?.('/')}>
        Home
      </button>
      <button type="button" className="footer-link-btn" onClick={() => onNavigate?.('/about')}>
        About
      </button>
      <button type="button" className="footer-link-btn" onClick={() => onNavigate?.('/blog')}>
        Blog
      </button>
      <button type="button" className="footer-link-btn" onClick={() => onNavigate?.('/privacy')}>
        Privacy
      </button>
      <button type="button" className="footer-link-btn" onClick={() => onOpenPrivacyChoices?.()}>
        Privacy Choices
      </button>
    </div>
    <div className="footer-meta">Source: COS</div>
  </div>
);

export default Footer;
